import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import RandomizeIcon from '@atlaskit/icon-lab/core/randomize';
import { ToolbarButton, ToolbarButtonGroup, ToolbarTooltip } from '@atlaskit/editor-toolbar';

const messages = defineMessages({
	remixToolbarTooltip: {
		id: 'highlight-actions.remix-action.toolbar-tooltip',
		defaultMessage: 'Remix',
		description:
			'Tooltip for the Remix button in the view page highlight actions inline toolbar that opens a modal to remix or regenerate the block content',
	},
	remixToolbarLabel: {
		id: 'highlight-actions.remix-action.toolbar-label',
		defaultMessage: 'Remix',
		description:
			'Label for the Remix button in the view page highlight actions inline toolbar that opens a modal to remix or regenerate the block content',
	},
});

export const RemixAction = ({
	isNewToolbarEnabled,
	onClick,
}: {
	isNewToolbarEnabled?: boolean;
	onClick?: () => void;
}) => {
	const { formatMessage } = useIntl();

	return isNewToolbarEnabled ? (
		<ToolbarTooltip content={formatMessage(messages.remixToolbarTooltip)}>
			<ToolbarButtonGroup>
				<ToolbarButton
					iconBefore={<RandomizeIcon label="" size="small" />}
					testId="highlight-actions-remix"
					onClick={onClick}
				>
					<FormattedMessage {...messages.remixToolbarLabel} />
				</ToolbarButton>
			</ToolbarButtonGroup>
		</ToolbarTooltip>
	) : (
		<ToolbarTooltip content={formatMessage(messages.remixToolbarTooltip)}>
			<Button
				appearance="subtle"
				iconBefore={RandomizeIcon}
				testId="highlight-actions-remix"
				onClick={onClick}
			>
				<FormattedMessage {...messages.remixToolbarLabel} />
			</Button>
		</ToolbarTooltip>
	);
};
